import React from "react";
import GoogleMapReact, {
  ChangeEventValue,
  ClickEventValue,
  MapOptions,
  Maps,
} from "google-map-react";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

interface GoogleMapProps {
  defaultZoom?: number;
  defaultCenter?: GoogleMapReact.Coords;
  zoom?: number;
  center?: GoogleMapReact.Coords;
  yesIWantToUseGoogleMapApiInternals?: boolean;
  onGoogleApiLoaded?(maps: { map: any; maps: any; ref: Element | null }): void;
  onClick?(value: ClickEventValue): any;
  draggable?: boolean;
  onChildMouseDown?(childKey: any, childProps: any, mouse: any): void;
  onChildMouseUp?(childKey: any, childProps: any, mouse: any): void;
  onChildMouseMove?(childKey: any, childProps: any, mouse: any): void;
  onChange?(value: ChangeEventValue): any;
  options?: MapOptions | ((maps: Maps) => MapOptions);
}

const GoogleMap: React.FC<GoogleMapProps> = ({ children, ...props }) => (
  <div className="w-full h-full">
    <GoogleMapReact
      bootstrapURLKeys={{
        key:
          process.env.NEXT_PUBLIC_API_KEY ||
          publicRuntimeConfig.API_KEY,
      }}
      {...props}
    >
      {children}
    </GoogleMapReact>
  </div>
);

export default GoogleMap;
